Backbone.Radio.channel('views').reply('form-endowment',function(options){
	var radio = Backbone.Radio.channel('pledgeform')
	var opts = {
		endowment:false
	}
	
	/*
	 *	Trigger	
	 *		Events
	 */
	var triggerUpdated = function(){
		radio.trigger("endowment:updated",{
			 endowment:opts.endowment
		})
	}	
	
	
	
	
	/*
	 *	The View
	 */
	var view = Marionette.View.extend({
		 template:_.template($("#tmpl-form-endowment").html())
		,events:{
			 "click input[type=radio]":"endowmentClicked"
		}
		,endowmentClicked:function(e){
			/* The endowment value is legacy and should eventually be changed
				to a true/false. But that would take updating the api call
				as well, which isn't in scope at the moment. */
			opts.endowment = $(e.currentTarget).val();
			
			triggerUpdated()
		}
		,onAttach:function(){
			var that = this;
			/*
				The donation module finishes before this one starts loading,
				so we miss the first trigger if there is something about
				the account that disables the sustaner type.
				We get pledgeData passed in, which does receive the event, 
				so that we can initiate correctly.  
			*/
			this.updateEndowmentText(options.pledgeData)

			radio.on("donation:updated",function(data){
				that.updateEndowmentText(data)	
			});
			
			/* pTooltip has its own lib file */
			this.$el.find('#endowmentReadMore').pTooltip();
		}
		,updateEndowmentText:function(data){
			if(data.type==='sustainer'){
				this.$el.find('#endowmentLabel span:first-child').html("Would you like to help WHRO by adding an extra $1 per month to go towards our Endowment?")
			}else if(data.type==='normal'){
				this.$el.find('#endowmentLabel span:first-child').html("Are you able to help WHRO by adding $5.00 for our Endowment Fund?")
			}else{ //installment
				this.$el.find('#endowmentLabel span:first-child').html("Would you like to help WHRO by adding an extra $1 per installment to go towards our Endowment?")
			}
		}
	})
	
	
	return new (view)();
});